import React, { useCallback, createContext, useState } from 'react';
import { DependenteEntidade, WebRecadParticipanteDadosEntidade, WebRecadPublicoAlvoEntidade } from '@entidades';
import { ArquivoUploadItem } from '@src/components/ArquivoUpload';

interface IRecadastramentoContext {
  salvarDadosRecadastramento: (parametros: WebRecadPublicoAlvoEntidade) => void;
  buscarDadosRecadastramento: () => Promise<WebRecadPublicoAlvoEntidade>;

  salvarRecadastramentosDisponiveis: (parametros: WebRecadPublicoAlvoEntidade[]) => void;
  buscarRecadastramentosDisponiveis: () => Promise<WebRecadPublicoAlvoEntidade[]>;

  salvarDadosParticipante: (parametros: WebRecadParticipanteDadosEntidade) => void;
  buscarDadosParticipante: () => Promise<WebRecadParticipanteDadosEntidade>;

  salvarDadosOriginais: (parametros: WebRecadParticipanteDadosEntidade) => void;
  buscarDadosOriginais: () => Promise<WebRecadParticipanteDadosEntidade>;

  salvarListaArquivo: (parametros: Array<ArquivoUploadItem>) => void; // eslint-disable-line no-unused-vars
  buscarListaArquivo: () => Promise<Array<ArquivoUploadItem>>;

  salvarListaDependentes: (parametros: Array<DependenteEntidade>) => void;
  buscarListaDependentes: () => Promise<Array<DependenteEntidade>>;

  limparDados: () => Promise<void>;
}

export enum GrupoRecadastramento {
  ATIVO = "ATIVO",
  ASSISTIDO = "ASSISTIDO",
  ASSISTIDO_ESPECIAL = "ASSISTIDO_ESPECIAL",
  SALDADO_EXTRAORD = "SALDADO_EXTRAORD",
  PENSIONISTA = "PENSIONISTA",
}

export const RecadastramentoContext = createContext<IRecadastramentoContext | null>(null);

export const RecadastramentoProvider: React.FC<any> = ({ children }) => {
  // const navigation = useNavigation<any>();

  const [RecadastramentosDisponiveis, setRecadastramentosDisponiveis] = useState<WebRecadPublicoAlvoEntidade[]>([]);
  const [DadosRecadastramento, setDadosRecadastramento] = useState<WebRecadPublicoAlvoEntidade>(null);
  const [DadosParticipante, setDadosParticipante] = useState<WebRecadParticipanteDadosEntidade>(null);
  const [DadosOriginais, setDadosOriginais] = useState<WebRecadParticipanteDadosEntidade>(null);
  // const [PassoAtivo, setPassoAtivo] = useState<Passo>(new Passo(ListaPassos[0]));
  // const [NumeroPassoAtual, setNumeroPassoAtual] = useState<number>(0);
  // const [ListaPassosDisponiveis, setListaPassosDisponiveis] = useState<Passo[]>(ListaPassos);
  const [ListaArquivo, setListaArquivo] = useState<Array<ArquivoUploadItem>>(new Array<ArquivoUploadItem>());
  const [ListaDependentes, setListaDependentes] = useState<DependenteEntidade[]>([]);

  const salvarRecadastramentosDisponiveis = useCallback(async (parametros: WebRecadPublicoAlvoEntidade[]) => {
    setRecadastramentosDisponiveis(parametros);
  }, []);

  const buscarRecadastramentosDisponiveis = useCallback(async () => {
    return RecadastramentosDisponiveis;
  }, [RecadastramentosDisponiveis]);

  const salvarDadosRecadastramento = useCallback(async (parametros: WebRecadPublicoAlvoEntidade) => {
    setDadosRecadastramento(parametros);
  }, []);

  const buscarDadosRecadastramento = useCallback(async () => {
    return DadosRecadastramento;
  }, [DadosRecadastramento]);

  const salvarDadosParticipante = useCallback(async (parametros: WebRecadParticipanteDadosEntidade) => {
    setDadosParticipante(parametros);
  }, []);

  const buscarDadosParticipante = useCallback(async () => {
    return DadosParticipante;
  }, [DadosParticipante]);

  const salvarDadosOriginais = useCallback(async (parametros: WebRecadParticipanteDadosEntidade) => {
    setDadosOriginais(parametros);
  }, []);

  const buscarDadosOriginais = useCallback(async () => {
    return DadosOriginais;
  }, [DadosOriginais]);

  /* --- ListaArquivo --- */

  const salvarListaArquivo = useCallback(async (parametros) => {
    setListaArquivo(parametros);
  }, []);

  const buscarListaArquivo = useCallback(async () => {
    return ListaArquivo;
  }, [ListaArquivo]);

  /* --- ListaArquivo --- */

  const salvarListaDependentes = useCallback(async (parametros) => {
    setListaDependentes(parametros);
  }, []);

  const buscarListaDependentes = useCallback(async () => {
    return ListaDependentes;
  }, [ListaDependentes]);

  const limparDados = useCallback(async () => {
    setRecadastramentosDisponiveis([]);
    setDadosRecadastramento(null);
    setDadosParticipante(null);
    setDadosOriginais(null);
    setListaArquivo(new Array<ArquivoUploadItem>());
    setListaDependentes([]);
  }, [])

  const metodos: IRecadastramentoContext = {
    salvarRecadastramentosDisponiveis, buscarRecadastramentosDisponiveis,
    salvarDadosRecadastramento, buscarDadosRecadastramento,
    salvarDadosParticipante, buscarDadosParticipante,
    salvarDadosOriginais, buscarDadosOriginais,
    salvarListaArquivo, buscarListaArquivo,
    salvarListaDependentes, buscarListaDependentes,
    limparDados
  }

  return (
    <RecadastramentoContext.Provider value={metodos}>
      {children}
    </RecadastramentoContext.Provider>
  );
}